export default [
  {
    path: "/auth/password/reset",
    name: "setPasswordReset",
    component: () =>
      import("@/modules/auth/components/password/SetNewPasswordPage"),
  },
];
